export const radius = {
  none: "rounded-none",
  xs: "rounded",
  sm: "rounded-lg",
  md: "rounded-xl",
  lg: "rounded-[14px]",
  xl: "rounded-[24px]",
  full: "rounded-full",
};

export const radiusStoriesControl = {
  control: {
    type: "select",
  },
  options: Object.keys(radius),
  description: "The radius of the element",
};
